<template>
  <div class="content-8">
    <div v-if="changLongTab" class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">每日长龙统计</span>
        </div>
        <div class="c8-menubox">
          <div class="menubar">
            <div
              v-for="tab in changLongTab"
              :key="`${tab.ruleType}-${tab.ruleCode}`"
              class="menubar__item"
              :class="{'active': currentChangLongType === tab.label}"
              @click="changeCLRule(tab)"
            >
              <span class="menubar__item__text">{{ tab.label }}</span>
              <div class="menubar__item__lightborder"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading v-if="isLoading" />
    <template v-else>
      <template v-if="meiRiCLStatsList">
        <div class="content-8__controlbar">
          <div class="content-8__controlbar__item">
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__title__text">{{ tabTitle }}</span>
              </div>
              <div class="c8-select__content">
                <a
                  v-for="tab in fieldsTab"
                  :key="tab.key"
                  class="c8-select__content__item button-outline"
                  :class="{'active': currentParams.field === tab.field}"
                  @click="changeField(tab)"
                >
                  <span class="button-outline__text">{{ tab.label }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="content-8__content">
          <table>
            <thead>
              <tr>
                <th rowspan="2">日期</th>
                <th :colspan="meiRiCLStatsList['biggestPeriodsCount']">开"{{ tableHeader }}"长龙出现条数</th>
              </tr>
              <tr>
                <th
                  v-for="column in meiRiCLStatsList['biggestPeriodsCount']"
                  :key="column"
                >{{ column + 1 }}期</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="rowData in meiRiCLStatsList['list']"
                :key="`${rowData.date}`"
              >
                <td>{{ rowData.date }}</td>
                <template v-for="(statsData, uniqIndex) in rowData.statistic">
                  <td :key="`tbody-${uniqIndex}-${statsData}`">{{ statsData }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <NoData v-else />
    </template>
  </div>
</template>

<script>
import { getMethods } from '@/utils/forWeb-Sean/meiRiChangLong'
import { getDailyDragon_web } from '@/api/desktop/statistic'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
export default {
  name: 'WebMeiRiChangLongTongJi',
  components: {
    Loading,
    NoData
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      changLongTab: null,
      fieldsTab: null,
      meiRiCLStatsList: null,
      // 用來紀錄上面的長龍 tabbar 當前點到的 tab
      currentChangLongType: '',
      currentParams: {
        ruleType: '',
        ruleCode: '',
        field: ''
      },
      tableHeader: '',
      lotteryCode: this.$route.params.lottery_code,
      isLoading: false
    }
  },
  computed: {
    tabTitle() {
      switch (this.lotteryType) {
        case 'pk10':
          return '筛选名次：'
        case 'ssc':
        case '11x5':
        case 'kl10':
          return '筛选球位：'
        case 'k3':
        case 'kl8':
        case 'xy28':
        default:
          return '玩法：'
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...getMethods,
    init() {
      this.changLongTab = this.getChangLongTab(this.lotteryType)
      this.tableHeader = this.changLongTab[0].headerLabel
      this.currentChangLongType = this.changLongTab[0].label
      this.fieldsTab = this.getfieldsTab({
        lotteryType: this.lotteryType,
        ruleType: this.changLongTab[0].ruleType,
        ruleCode: this.changLongTab[0].ruleCode
      })

      this.currentParams['ruleType'] = this.changLongTab[0].ruleType
      this.currentParams['ruleCode'] = this.changLongTab[0].ruleCode
      const isZongHeType = this.lotteryType === 'k3' || this.lotteryType === 'xy28' || this.lotteryType === 'kl8'
      this.currentParams['field'] = isZongHeType ? 'all' : 'hm1'

      this.getMeiRiCLStatistics(this.currentParams)
    },
    async getMeiRiCLStatistics(params) {
      const query = {
        count: 30,
        code: this.lotteryCode,
        ...params
      }
      this.isLoading = true
      const [data, error] = await getDailyDragon_web(query)
      if (error) return
      // 每日資料最少要 4 期 (畫面好看)
      data.biggestPeriodsCount = data.biggestPeriodsCount >= 4 ? data.biggestPeriodsCount : 4
      // 補齊每一筆資料 使得list資料長度一致
      data.list.forEach((each) => {
        for (let i = 0; i < data.biggestPeriodsCount; ++i) {
          if (!/^\d+$/.test(each.statistic[i])) each.statistic[i] = ''
        }
      })

      this.meiRiCLStatsList = data
      this.isLoading = false
    },
    async changeCLRule(params) {
      this.fieldsTab = this.getfieldsTab({
        lotteryType: this.lotteryType,
        ruleType: params.ruleType,
        ruleCode: params.ruleCode
      })
      this.currentParams.ruleType = this.fieldsTab[0].ruleType
      this.currentParams.ruleCode = this.fieldsTab[0].ruleCode
      this.currentParams.field = this.fieldsTab[0].field
      this.currentChangLongType = params.label
      await this.changeField(this.fieldsTab[0])
      this.tableHeader = params.headerLabel
    },
    async changeField({ field, ruleCode, ruleType }) {
      // 快樂十分 -> 尾大尾小長龍
      if (field === 'allmantissa' && ruleType === 'hmWeiShuDaXiao') ruleType = 'zongHeDaXiao'
      // 各彩種的總和需替換 ruleType 為總和類型
      if (field === 'all' && /^hm/.test(ruleType)) ruleType = ruleType.replace('hm', 'zongHe')
      if (field === 'sumguanya' && /^hm/.test(ruleType)) ruleType = ruleType.replace('hm', 'guanYaHe')
      this.currentParams = Object.assign({}, { ruleType, ruleCode, field })
      await this.getMeiRiCLStatistics(this.currentParams)
    }
  }
}
</script>

